module.exports = __webpack_public_path__ + "img/rbcn_pro_4.601eaa54.png";